export default "__VITE_ASSET__DdPbREtz__"